import React from "react";
import "./Legal.css";
import { FiKey, FiBarChart, FiSliders, FiSettings } from "react-icons/fi";

export default function CookiePolicy() {

  // Professional Legal Version ID
  const legalId = "BAILCP-V-CP-2.2"; // CP = Cookie Policy
  const lastUpdated = "Dec 10, 2025";

  return (
    <div className="legal-page">
      <h1>Cookie Policy</h1>

      {/* Legal Version / ID */}
      <div className="legal-meta">
        <span>Legal ID: {legalId}</span>
        <span>Last Updated: {lastUpdated}</span>
      </div>

      <p>
        BodhAI uses cookies to enhance performance, personalize your experience, 
        and understand how users interact with the platform.
      </p>

      <ul className="legal-list">
        <li>
          <FiKey className="legal-icon" />
          Essential cookies: Keep you logged in and ensure core platform functionality.
        </li>

        <li>
          <FiBarChart className="legal-icon" />
          Analytics cookies: Help us understand user activity and improve features.
        </li>

        <li>
          <FiSliders className="legal-icon" />
          Preference cookies: Save your settings such as theme, language, and layout.
        </li>

        <li>
          <FiSettings className="legal-icon" />
          You can block or manage cookies anytime via your browser settings.
        </li>
      </ul>

      <p>
        Cookies help us deliver a reliable and personalized experience, but you 
        always remain in control of how they are used.
      </p>
    </div>
  );
}
